import Client from 'shopify-buy';
import { store } from './react-initialize';
import * as Sentry from '@sentry/browser';

export default function checkoutOnShopify() {
   const client = Client.buildClient(App.shopifyCheckout.clientDetails);

   const products = store.getState().headerState.miniCart.products;

   const nonExistentProducts = products.filter(product => !product.variantId);
   if (nonExistentProducts.length) {
      const skuList = nonExistentProducts.map(product => product.sku).join(', ');
      throw new Error(
         `Cannot check out. The following products don't exist on Shopify: ${skuList}`
      );
   }

   const createCheckout = client.checkout
      .create({
         lineItems: products.map(product => ({
            variantId: product.variantId,
            quantity: product.quantity,
         })),
      })
      .then(checkout => {
         const url = new URL(App.shopifyCheckout.ssoRoute);
         url.searchParams.set('return_to', checkout.webUrl);
         window.location = url;
      })
      .catch(e => {
         const invalidProducts = getInvalidProducts(e, products);
         if (invalidProducts) {
            Sentry.captureMessage(e.message, {
               extra: {
                  'Invalid Variants in Cart': invalidProducts,
               },
            });
            const joinedSkus = invalidProducts.map(v => v.sku).join(', ');
            throw new Error(_js(`Cannot check out. Some items have problems: ${joinedSkus}`));
         } else {
            Sentry.captureException(e);
            throw new Error(_js('Checkout is currently unavailable. Please try again later.'));
         }
      });

   LoadingIndicator.withPromise(createCheckout, {
      pendingMessage: _js('Creating checkout'),
      useErrorResponseAsFailureMessage: true,
      hideSuccessMessage: true,
   });
}

/**
 * Returns an array of products that Shopify rejected if there was an
 * issue during checkout creation.
 *
 * @param e The exception thrown if Shopify rejects checkout creation
 * @param products The array of products in the user's cart
 * @return array of rejected products
 */
function getInvalidProducts(e, products) {
   try {
      const invalidVariantMessage = 'Variant is invalid';
      const responses = JSON.parse(e.message);
      return responses.reduce((filteredResponses, response) => {
         if (response.message === invalidVariantMessage) {
            const index = parseInt(response.field[2]);
            if (!isNaN(index)) {
               filteredResponses.push(products[index]);
            }
         }
         return filteredResponses;
      }, []);
   } catch (err) {
      return [];
   }
}
